

























































import { Component, Vue, Provide } from "vue-property-decorator";
import Card from "@/components/Card.vue";
import arts from "@/arts";

interface Art {
  title: string;
  description: string;
  tags: string[];
}

@Component({
  components: {
    Card
  }
})
export default class Home extends Vue {
  @Provide() arts: Art[] = arts;
  @Provide() keyword: string = "";
  get searchResult() {
    return this.keyword
      ? this.arts.filter(art => art.tags.includes(this.keyword.toLowerCase()))
      : this.arts;
  }
}
